import { isTrue } from 'utils/validators';
import { required } from 'vuelidate/lib/validators';
var BookingCancelationValidationService = /** @class */ (function () {
    function BookingCancelationValidationService() {
    }
    BookingCancelationValidationService.formValidations = {
        form: {
            bookingSource: { required: required },
            refundReason: { required: required },
            refundType: { required: required },
            agreeToTerms: { isTrue: isTrue }
        }
    };
    BookingCancelationValidationService.errorMessages = {
        bookingSource: { required: 'payments.bookingCancelation.validation.required' },
        refundReason: { required: 'payments.bookingCancelation.validation.required' },
        refundType: { required: 'payments.bookingCancelation.validation.required' },
        agreeToTerms: { isTrue: 'groupBooking.step4.terms.isTrue' }
    };
    return BookingCancelationValidationService;
}());
export default BookingCancelationValidationService;
